import { FilterOrManual } from "shared/helpers/getFilterOrManual";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { isDefineProjectOrderScopeAllowed } from "shared/pages/teams/helpers/isDefineProjectOrderAllowed";
import { isOrganizationsEntityType } from "shared/pages/teams/helpers/prepareCustomSortingGridFilter";
import { replaceFilterParamForManualTab } from "./replaceFilterParamForManualTab";

type RequestParams = Record<string, any>;

interface MethodParamsInput {
  filter?: any;
  offset?: number;
  page?: number;
  accountId?: string;
  sort?: any;
  isLite?: boolean;
  channelOwnerId?: string;
  moderationType?: unknown;
  enableFeedParam?: Record<string, any>;
  onlyBooksParam?: Record<string, any>;
  isLiteParam?: Record<string, any>;
  noEmptyChannelParam?: Record<string, any>;
  authorIdsFromTeamIdsParam?: Record<string, any>;
  entityType?: string;
  defineProjectOrderForTab?: boolean;
}

const getManualProjectsParam = (finalFilter: Record<string, any> | undefined) => {
  const projects = finalFilter?.projectsShortInfos?.map((item: any) => item.projectId) ?? []
  return projects.length > 0 ? { projectIds: projects } : { projectIds: [''] }
}

const resolveFilterProjectIds = (
  finalFilter: Record<string, any> | undefined,
  moderationType: unknown,
  entityType?: string,
) => {
  const isOrganizationsCustomSorting = (
    !!finalFilter?.customSorting && isOrganizationsEntityType(entityType)
  )

  if (isOrganizationsCustomSorting) {
    return {}
  }

  if (!finalFilter?.customSorting) {
    return {}
  }

  const hasProjectIds = (finalFilter?.projectIds?.filter(Boolean)?.length ?? 0) > 0
  return hasProjectIds ? {} : { projectIds: [] }
}

const resolveOrganizationsCustomSortingRequestParams = (
  finalFilter: Record<string, any> | undefined,
  entityType?: string,
) => {
  if (!finalFilter?.customSorting || !isOrganizationsEntityType(entityType)) {
    return {}
  }

  return {
    ...(finalFilter.contextNames?.length ? { contextNames: finalFilter.contextNames } : {}),
  }
}

const normalizeFilterForRequest = (
  finalFilter: Record<string, any> | undefined,
): Record<string, any> => {
  if (!finalFilter) {
    return {}
  }

  if (finalFilter.competitionTypes?.length) {
    const { sort: _sort, ...rest } = finalFilter;
    return {
      ...rest,
      types: finalFilter.competitionTypes,
      contexts: [],
      competitionStatus: [...(finalFilter.projectStatus || [])]
    }
  }

  if (finalFilter.customSorting) {
    return finalFilter
  }

  if (finalFilter.lockSorting) {
    return {
      ...finalFilter,
      sort: finalFilter.lockSortingType,
      projectFilter: finalFilter.lockSortingType
    }
  }

  const { projectIds, ...rest } = finalFilter
  return rest
}

export const methodParams = (
  requestType: FilterOrManual,
  data: MethodParamsInput
): RequestParams => {
  const {
    filter: finalFilter,
    offset,
    page,
    accountId,
    sort,
    isLite,
    channelOwnerId,
    moderationType,
    entityType,
    isLiteParam,
    onlyBooksParam = {},
    noEmptyChannelParam = {},
    authorIdsFromTeamIdsParam,
    defineProjectOrderForTab,
    enableFeedParam,
  } = data;

  const commonBase = {
    limit: finalFilter?.limit ?? 20,
  };
  const normalizedFilter = normalizeFilterForRequest(finalFilter);

  if (requestType === FilterOrManual.FILTER) {
    return {
      ...commonBase,
      ...normalizedFilter,
      ...onlyBooksParam,
      ...noEmptyChannelParam,
      ...authorIdsFromTeamIdsParam,
      ...isLiteParam,
      ...enableFeedParam,
      hasProductCards: finalFilter?.hasProductCards || false,
      ...(page ? { page } : {}),
      ...(offset ? { offset } : {}),
      ...(isLite ? { isLite} : {}),
      ...(accountId ? { accountId } : {}),
      ...(!!normalizedFilter?.sort ? { sort: normalizedFilter.sort } : {}),
      ...resolveFilterProjectIds(finalFilter, moderationType, entityType),
      ...(moderationType === ModerationType.Outer ? { mainPage: false } : {}),
      ...(finalFilter?.competitionTypes?.length ? { competitionTypes: finalFilter.competitionTypes } : {}),
      hasAnnotation: false
    };
  }

  if (requestType === FilterOrManual.MANUAL) {
    const resolvedSort = sort ?? finalFilter?.sort;
    const isOrganizationsCustomSorting = (
      !!finalFilter?.customSorting && isOrganizationsEntityType(entityType)
    )
    const manualProjects = getManualProjectsParam(finalFilter);
    const limit = manualProjects?.projectIds?.length ?? 20;
    const projectFilter = replaceFilterParamForManualTab(finalFilter);

    return {
      ...commonBase,
      ...authorIdsFromTeamIdsParam,
      ...isLiteParam,
      projectStatus: [1, 10],
      ...(!isOrganizationsCustomSorting ? { isContextIgnored: true } : {}),
      mainPage: false,
      hasProductCards: finalFilter?.hasProductCards || false,
      ...(resolvedSort ? { sort: resolvedSort } : {}),
      ...(projectFilter ? {projectFilter: projectFilter} : {}),
      ...(finalFilter?.customSorting && isDefineProjectOrderScopeAllowed(
        moderationType,
        entityType,
        undefined,
        { forTab: defineProjectOrderForTab },
      )
        ? { customSorting: true }
        : {}),
      ...(finalFilter?.customSorting && isOrganizationsEntityType(entityType)
        ? {}
        : getManualProjectsParam(finalFilter)),
      ...resolveOrganizationsCustomSortingRequestParams(finalFilter, entityType),
      ...(channelOwnerId && { authorIds: [channelOwnerId] }),
      hasAnnotation: false,
      limit
    };
  }

  return {
    ...commonBase,
  };
};
import { FilterOrManual } from "shared/helpers/getFilterOrManual";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { isDefineProjectOrderScopeAllowed } from "shared/pages/teams/helpers/isDefineProjectOrderAllowed";
import { isOrganizationsEntityType } from "shared/pages/teams/helpers/prepareCustomSortingGridFilter";
import { replaceFilterParamForManualTab } from "./replaceFilterParamForManualTab";

type RequestParams = Record<string, any>;

interface MethodParamsInput {
  filter?: any;
  offset?: number;
  page?: number;
  accountId?: string;
  sort?: any;
  isLite?: boolean;
  channelOwnerId?: string;
  moderationType?: unknown;
  enableFeedParam?: Record<string, any>;
  onlyBooksParam?: Record<string, any>;
  isLiteParam?: Record<string, any>;
  noEmptyChannelParam?: Record<string, any>;
  authorIdsFromTeamIdsParam?: Record<string, any>;
  entityType?: string;
  defineProjectOrderForTab?: boolean;
}

const getManualProjectsParam = (finalFilter: Record<string, any> | undefined) => {
  const projects = finalFilter?.projectsShortInfos?.map((item: any) => item.projectId) ?? []
  return projects.length > 0 ? { projectIds: projects } : { projectIds: [''] }
}

const resolveFilterProjectIds = (
  finalFilter: Record<string, any> | undefined,
  moderationType: unknown,
  entityType?: string,
) => {
  const isOrganizationsCustomSorting = (
    !!finalFilter?.customSorting && isOrganizationsEntityType(entityType)
  )

  if (isOrganizationsCustomSorting) {
    return {}
  }

  if (!finalFilter?.customSorting) {
    return {}
  }

  const hasProjectIds = (finalFilter?.projectIds?.filter(Boolean)?.length ?? 0) > 0
  return hasProjectIds ? {} : { projectIds: [] }
}

const resolveOrganizationsCustomSortingRequestParams = (
  finalFilter: Record<string, any> | undefined,
  entityType?: string,
) => {
  if (!finalFilter?.customSorting || !isOrganizationsEntityType(entityType)) {
    return {}
  }

  return {
    ...(finalFilter.contextNames?.length ? { contextNames: finalFilter.contextNames } : {}),
  }
}

const normalizeFilterForRequest = (
  finalFilter: Record<string, any> | undefined,
): Record<string, any> => {
  if (!finalFilter) {
    return {}
  }

  if (finalFilter.competitionTypes?.length) {
    const { sort: _sort, ...rest } = finalFilter;
    return {
      ...rest,
      types: finalFilter.competitionTypes,
      contexts: [],
      competitionStatus: [...(finalFilter.projectStatus || [])]
    }
  }

  if (finalFilter.customSorting) {
    return finalFilter
  }

  if (finalFilter.lockSorting) {
    return {
      ...finalFilter,
      sort: finalFilter.lockSortingType,
      projectFilter: finalFilter.lockSortingType
    }
  }

  const { projectIds, ...rest } = finalFilter
  return rest
}

export const methodParams = (
  requestType: FilterOrManual,
  data: MethodParamsInput
): RequestParams => {
  const {
    filter: finalFilter,
    offset,
    page,
    accountId,
    sort,
    isLite,
    channelOwnerId,
    moderationType,
    entityType,
    isLiteParam,
    onlyBooksParam = {},
    noEmptyChannelParam = {},
    authorIdsFromTeamIdsParam,
    defineProjectOrderForTab,
    enableFeedParam,
  } = data;

  const commonBase = {
    limit: finalFilter?.limit ?? 20,
  };
  const normalizedFilter = normalizeFilterForRequest(finalFilter);

  if (requestType === FilterOrManual.FILTER) {
    return {
      ...commonBase,
      ...normalizedFilter,
      ...onlyBooksParam,
      ...noEmptyChannelParam,
      ...authorIdsFromTeamIdsParam,
      ...isLiteParam,
      ...enableFeedParam,
      hasProductCards: finalFilter?.hasProductCards || false,
      ...(page ? { page } : {}),
      ...(offset ? { offset } : {}),
      ...(isLite ? { isLite} : {}),
      ...(accountId ? { accountId } : {}),
      ...(!!normalizedFilter?.sort ? { sort: normalizedFilter.sort } : {}),
      ...resolveFilterProjectIds(finalFilter, moderationType, entityType),
      ...(moderationType === ModerationType.Outer ? { mainPage: false } : {}),
      ...(finalFilter?.competitionTypes?.length ? { competitionTypes: finalFilter.competitionTypes } : {}),
      hasAnnotation: false
    };
  }

  if (requestType === FilterOrManual.MANUAL) {
    const resolvedSort = sort ?? finalFilter?.sort;
    const isOrganizationsCustomSorting = (
      !!finalFilter?.customSorting && isOrganizationsEntityType(entityType)
    )
    const manualProjects = getManualProjectsParam(finalFilter);
    const limit = manualProjects?.projectIds?.length ?? 20;
    const projectFilter = replaceFilterParamForManualTab(finalFilter);

    return {
      ...commonBase,
      ...authorIdsFromTeamIdsParam,
      ...isLiteParam,
      projectStatus: [1, 10],
      ...(!isOrganizationsCustomSorting ? { isContextIgnored: true } : {}),
      mainPage: false,
      hasProductCards: finalFilter?.hasProductCards || false,
      ...(resolvedSort ? { sort: resolvedSort } : {}),
      ...(projectFilter ? {projectFilter: projectFilter} : {}),
      ...(finalFilter?.customSorting && isDefineProjectOrderScopeAllowed(
        moderationType,
        entityType,
        undefined,
        { forTab: defineProjectOrderForTab },
      )
        ? { customSorting: true }
        : {}),
      ...(finalFilter?.customSorting && isOrganizationsEntityType(entityType)
        ? {}
        : getManualProjectsParam(finalFilter)),
      ...resolveOrganizationsCustomSortingRequestParams(finalFilter, entityType),
      ...(channelOwnerId && { authorIds: [channelOwnerId] }),
      hasAnnotation: false,
      limit
    };
  }

  return {
    ...commonBase,
  };
};
